import DetailScreen from "./DetailScreen";
export default DetailScreen;
